module.exports = __webpack_public_path__ + "img/motor_no35.52fd5ed3.jpg";